import React from 'react'
import './blogmusic.css'
import { ImArrowRight2 } from 'react-icons/im';
import Fade from 'react-reveal/Fade';

const Blogmusic = () => {
  return (
    <div className='Blogmusic'>
      <Fade><div className="BlogmusicHeading">MUSIC <a href="">#MUSICIANTRACKS</a></div></Fade>
      <div className="BlogmusicHeadingline"></div>
      <div className="BlogmusicCol">
        <div className="BlogmusicCol1">
          <div className="BlogmusicCol1Mainrow">
            <a href=""> <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/music-blog-post-08.jpg" alt="" /></a>
            <div className="BlogmusicCol1MainrowText">
              <div className="BlogmusicCol1MainrowTextBy">
                BY:
                <a href="">MUSICIAN</a>
                / <a href="" className="BlogmusicCol1MainrowTextByActive">MUSIC</a>
                / <p>MAY21</p>

              </div>
              <a href="" className="BlogmusicCol1MainrowTextTitle">Prayer’s ft. Kat Von D presents “Black Leather”</a>
              <div className="BlogmusicCol1MainrowTextDesc"> Prayer’s new track, great sound. Listen to “Black Leather”.</div>
              <a href="" className='BlogmusicCol1MainrowTextBtn'>READ MORE</a> <a href="" className='BlogmusicCol1MainrowTextArrow'><ImArrowRight2 /></a>

            </div>
          </div>

          <div className="BlogmusicCol1Row">
            <div className="BlogmusicCol1Box">
              <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/music-blog-post-09.jpg" alt="" />

              <div className="BlogmusicCol1BoxBy">
                BY: <a href="">MUSICIAN</a>/<a href="" className="BlogmusicCol1BoxActive">MUSIC</a>/ <p>MAY21</p>
              </div>

              <a href="" className='BlogmusicCol1BoxTitle'>Ellie Goulding - five weeks in Billboard “The hot 100”</a>
            </div>
            <div className="BlogmusicCol1Box">
              <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/music-blog-post-10.jpg" alt="" />
              <div className="BlogmusicCol1BoxBy">
                BY: <a href="">MUSICIAN</a>/<a href="" className="BlogmusicCol1BoxActive">MUSIC</a>/ <p>MAY21</p>
              </div>
              <a href="" className='BlogmusicCol1BoxTitle'>Megan Trainor releases new track</a>
            </div>
          </div>
          <div className="BlogmusicCol1Row">
            <div className="BlogmusicCol1Box">
              <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/music-blog-post-11.jpg" alt="" />

              <div className="BlogmusicCol1BoxBy">
                BY: <a href="">MUSICIAN</a>/<a href="" className="BlogmusicCol1BoxActive">MUSIC</a>/ <p>MAY21</p>
              </div>

              <a href="" className='BlogmusicCol1BoxTitle'>Skrillex’s ‘Hotline Bling’ x ‘BBHMM’ x ‘Summit’</a>
            </div>
            <div className="BlogmusicCol1Box">
              <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/music-blog-post-12.jpg" alt="" />
              <div className="BlogmusicCol1BoxBy">
                BY: <a href="">MUSICIAN</a>/<a href="" className="BlogmusicCol1BoxActive">MUSIC</a>/ <p>MAY21</p>
              </div>
              <a href="" className='BlogmusicCol1BoxTitle'>Listen to Coachella 2016 - Guns’n’Roses performance</a>
            </div>
          </div>
          <a href="" className='BlogmusicCol1Btn'> ALL MUSIC <ImArrowRight2 /></a>

        </div>

        <div className="BlogmusicCol2">
          <div className="BlogmusicCol2Heading">
            TOP 10 PICKS
          </div>
          <div className="BlogmusicCol2HeadingLine"></div>

          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">POP/R&B</div>
              <div className="BlogmusicCol2RowTitle">"Think of you"</div>
              <p className="BlogmusicCol2RowBy">-Terrace Martin</p>
            </div>
          </a>


          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">HOUSE</div>
              <div className="BlogmusicCol2RowTitle">"DVBBS & SHAUNK FRANK"</div>
              <p className="BlogmusicCol2RowBy">-LA LA LAND ft. Delaney Janemartin</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">POP/R&B</div>
              <div className="BlogmusicCol2RowTitle">"Think of you"</div>
              <p className="BlogmusicCol2RowBy">-Terrace Martin</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">pop</div>
              <div className="BlogmusicCol2RowTitle">"Alessia cara"</div>
              <p className="BlogmusicCol2RowBy">-Here</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">POP</div>
              <div className="BlogmusicCol2RowTitle">"Shawn Mendes"</div>
              <p className="BlogmusicCol2RowBy">-Stitches</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">POP</div>
              <div className="BlogmusicCol2RowTitle">"Meghan trainer featuring John legend"</div>
              <p className="BlogmusicCol2RowBy">-Like I'am Gonna Lose you</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">POP</div>
              <div className="BlogmusicCol2RowTitle">"The Weekend"</div>
              <p className="BlogmusicCol2RowBy">-In the Night</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">INDIE/POP</div>
              <div className="BlogmusicCol2RowTitle">"Ellie Goulding"</div>
              <p className="BlogmusicCol2RowBy">-On My Mind</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">POP</div>
              <div className="BlogmusicCol2RowTitle">"The Weekend"</div>
              <p className="BlogmusicCol2RowBy">-Can't Feel My Face</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">HIP HOP</div>
              <div className="BlogmusicCol2RowTitle">"Travi$ Scott"</div>
              <p className="BlogmusicCol2RowBy">-Antidote</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>
          <a href='' className="BlogmusicCol2Row">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/blog/audio-post-img.png" alt="" />
            <div className="BlogmusicCol2RowText">
              <div className="BlogmusicCol2RowType">ALTERNATIVE POP</div>
              <div className="BlogmusicCol2RowTitle">"Elle King"</div>
              <p className="BlogmusicCol2RowBy">-Ex's and Oh's</p>
            </div>
          </a>
          <div className="BlogmusicCol2RowLine"></div>





        </div>

      </div >
      <div className="BlogmusicEndline"></div>

    </div >
  )
}

export default Blogmusic
